import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/** Pipe de formatação de data no padrão brasileiro (dd/MM/yyyy). */
@Pipe({
  name: 'dateBr',
  standalone: true,
})
export class AppDateBrPipe implements PipeTransform {
  transform(value: string | Date | null, hr = true): string {
    if (!value) {
      return '';
    }

    const format = hr ? 'dd MMM y, HH:mm' : 'dd MMM y';

    return formatDate(value, format, 'pt-BR').replace('.', '') + (hr ? 'min' : '');
  }
}
